import {VisitPlanRouteModel} from "./visit-plan-route.model";
import {VisitScheduleDayModel} from "./visit-schedule-day.model";
import {VisitPlanRouteStatusEnum} from "../enums/visit-plan-route-status.enum";
import {isVisitScheduleDayDispatchedById} from "./visit-schedule-day.functions";

export function isVisitPlanRouteDispatched(route?: VisitPlanRouteModel): boolean {
  if (!route) return false;
  return route.status === VisitPlanRouteStatusEnum.DISPATCHED ||
    route.status === VisitPlanRouteStatusEnum.PARTIAL_DISPATCHED;
}

export function isVisitPlanRouteBlocked(route: VisitPlanRouteModel, days: VisitScheduleDayModel[]): boolean {
  return isVisitPlanRouteDispatched(route) ||
    isVisitScheduleDayDispatchedById(days, route?.visitScheduleDayId);
}
